<style scoped>

* {
    border: 0px black solid;
}

.project_title {
  font-size: 40px;
  font-weight: bold;
  font-family: "Open Sans", sans-serif;
  padding-bottom: 40px;
  padding-top: 100px;
}

.description_text {
  font-size: 15px;
  font-family: "Roboto Mono", monospace;
  padding-bottom: 10px;
}

.tags {
  padding-top: 10px;
  font-size: 15px;
  font-style: italic;
  font-family: "Roboto Mono", monospace;

}

a:hover {
  color: hotpink;
  text-decoration: none;

}

a {
  color: gray;
}

.content {
  padding-bottom: 40px;
}

</style>

<template>
  <b-container fluid>
    <MenuBar/>
    <b-row>
      <b-col md="12">
        <p class="project_title">Surveillance Stories</p>
      </b-col>
    </b-row>



    <b-row class="content">
      <b-col md="4">
        <div class="description_text">
        <p class="tags">Web development, web design, commissioned work</p>
<p>Surveillance Stories is a research project exploring the relationship with AI based surveillance and the human body. The website presents a series of conversations with people with an interest in surveillance and public space, design, art, artificial intelligence, technology and social justice. </p>
<p>Together with Gill Balwdin, I've worked on developing the website using Bootstrap Vue.</p>
      </div>
      </b-col>
<b-col md="8">
        <b-row>
          <b-col md="10" offset-md="1">
            <b-img class="img-fluid" src="media/surveillance/front.png"></b-img>
      </b-col>
    </b-row>
    <b-row>
      <b-col md="10" offset-md="1">
        <b-img class="img-fluid" src="media/surveillance/luke.png"></b-img>
  </b-col>
</b-row>
</b-col>

    </b-row>

  </b-container>

</template>

<script>
import MenuBar from './MenuBar'
export default {
    name: 'SurveillancePage',
    data: function() {
        return {
        }
    },
    components: {
        MenuBar
    }
}

</script>
